import type { Skill, SkillDesignation } from '@/models/taxonomy/skills';

export const normalizeUserJobsSkills = (
  profileSkills: Skill[]
): SkillDesignation[] => {
  const uniqueSkills = profileSkills.filter(
    (current, index, list) =>
      list.findIndex((s) => s.id === current.id) === index
  );

  const skills = uniqueSkills.map((profileSkill) => {
    const normalizedSkill: SkillDesignation = {
      id: profileSkill.id, // this is the skill id
      score: profileSkill.score ?? 0,
      label: profileSkill.source,
      skill: {
        id: profileSkill.id,
        name_pt: profileSkill.name_pt,
        name_en: profileSkill.name_en,
      },
    };

    return normalizedSkill;
  });

  return skills;
};
